export default {
  // 页面标题和副标题
  'page.mainTitle': 'Discord时间戳生成器',
  'page.mainTitleSEO': 'Discord时间戳生成器 - 创建动态<t:format>代码',
  'page.subtitle': '生成Discord时间戳，自动为所有人转换时区',

  // 生成器工具部分
  'page.generatorTitle': '交互式Discord时间戳生成器',
  'page.selectDateTime': '选择日期和时间：',
  'page.chooseFormat': '选择显示格式：',
  'page.generatedCode': '生成的Discord代码：',
  'page.preview': 'Discord中的预览：',
  'page.copyCode': '复制代码',

  // 格式选项
  'page.format.t': '短时间',
  'page.format.t.example': '下午4:30',
  'page.format.t.desc': '仅显示时间，短格式',

  'page.format.T': '长时间',
  'page.format.T.example': '下午4:30:00',
  'page.format.T.desc': '仅显示时间，包含秒数',

  'page.format.d': '短日期',
  'page.format.d.example': '2024/12/31',
  'page.format.d.desc': '仅显示日期，短格式',

  'page.format.D': '长日期',
  'page.format.D.example': '2024年12月31日',
  'page.format.D.desc': '显示完整日期',

  'page.format.f': '短日期时间',
  'page.format.f.example': '2024年12月31日 下午4:30',
  'page.format.f.desc': '最常用格式',

  'page.format.F': '长日期时间',
  'page.format.F.example': '2024年12月31日星期二 下午4:30',
  'page.format.F.desc': '完整的日期和时间，包含星期',

  'page.format.R': '相对时间',
  'page.format.R.example': '2小时前 / 3天后',
  'page.format.R.desc': '动态倒计时或已过时间',

  // 格式参考表
  'page.formatReference': 'Discord时间戳格式参考',
  'page.formatCode': '格式代码',
  'page.style': '样式',
  'page.exampleOutput': '示例输出',
  'page.useCase': '使用场景',

  'page.useCase.t': '活动开始时间',
  'page.useCase.T': '精确计时',
  'page.useCase.d': '紧凑日期显示',
  'page.useCase.D': '完整日期显示',
  'page.useCase.f': '通用用途',
  'page.useCase.F': '正式公告',
  'page.useCase.R': '倒计时、事件计时',

  // 使用说明部分
  'page.howToUse': '如何使用Discord时间戳',
  'page.step1': '生成你的时间戳代码',
  'page.step1Desc': '使用上面的工具选择日期/时间和格式',

  'page.step2': '复制生成的代码',
  'page.step2Desc': '示例：<t:1735689000:F>',

  'page.step3': '粘贴到任何Discord消息中',
  'page.step3Desc': '适用于文本频道、私信、帖子和论坛',

  'page.step4': '每个人都能看到自己时区的时间！',
  'page.step4Desc': 'Discord会自动转换为每个用户的本地时间',

  // FAQ部分
  'page.faq': 'Discord时间戳常见问题',

  'page.faq.q1': '什么是Discord时间戳？',
  'page.faq.a1': 'Discord时间戳使用Unix纪元时间配合特殊格式代码（<t:时间戳:格式>），可以显示自动适应每个用户本地时区的动态时间。',

  'page.faq.q2': '为什么使用Discord时间戳而不是直接输入时间？',
  'page.faq.a2': 'Discord时间戳会自动转换为每个用户的本地时区，所以每个人都能看到适合自己地区的正确时间。这在跨时区协调活动时非常有用，避免混淆。',

  'page.faq.q3': '我应该使用哪种格式？',
  'page.faq.a3': '使用 <t:时间戳:R> 进行倒计时和活动提醒，使用 <t:时间戳:F> 进行正式公告，使用 <t:时间戳:f> 作为通用格式。',

  'page.faq.q4': 'Discord时间戳在所有频道都有效吗？',
  'page.faq.a4': '是的！Discord时间戳在文本频道、私信、帖子、论坛，甚至频道主题中都有效。',

  'page.faq.q5': '可以在嵌入消息中使用Discord时间戳吗？',
  'page.faq.a5': '可以，使用Discord机器人时，时间戳可以在嵌入消息的描述和字段值中使用。',

  'page.faq.q6': '如果使用无效的时间戳会发生什么？',
  'page.faq.a6': 'Discord会直接显示原始代码而不进行转换。请确保使用有效的Unix时间戳。',

  // 相关工具部分
  'page.relatedTools': '相关时间戳工具',
  'page.needUnixTimestamp': '需要Unix时间戳？',
  'page.needUnixTimestampDesc': '使用我们的Unix时间戳转换器将任何日期转换为纪元时间。',
  'page.checkYouTubeTool': '或者查看YouTube时间戳创建器',

  // 常见用例
  'page.commonUseCases': '常见使用场景',
  'page.useCase1.title': '活动调度',
  'page.useCase1.desc': '公告游戏之夜、电影观看派对或社区活动',

  'page.useCase2.title': 'Raid计时器',
  'page.useCase2.desc': '跨不同时区协调游戏会话',

  'page.useCase3.title': '发布倒计时',
  'page.useCase3.desc': '为游戏发布、专辑首发或更新制造期待',

  'page.useCase4.title': '会议提醒',
  'page.useCase4.desc': '在社区服务器中安排团队会议',

  'page.useCase5.title': '比赛截止时间',
  'page.useCase5.desc': '为抽奖和竞赛设置明确的截止时间',

  'page.useCase6.title': '服务器活动',
  'page.useCase6.desc': '追踪周年纪念、里程碑和特殊场合',
};
